import Journeys from '@/models/Journeys'
import { CollectionTransformer } from '@/transformers/index'
import { JourneyTransformer } from '@/transformers/JourneyTransformer'
import { NewJourneyTransformer } from '@/transformers/NewJourneyTransformer'

export class JourneysTransformer {
    constructor (
        collectionTransformer = new CollectionTransformer(),
        journeyTransformer = new JourneyTransformer(),
        newJourneyTransformer = new NewJourneyTransformer()
    ) {
        this.collectionTransformer = collectionTransformer
        this.journeyTransformer = journeyTransformer
        this.newJourneyTransformer = newJourneyTransformer
    }

    transform (data) {
        return new Journeys(
            this.collectionTransformer.transform(this.journeyTransformer, Array.isArray(data.processedJourneys)
                ? data.processedJourneys.map(pJ => ({ ...pJ, type: 'processed' }))
                : []
            ),
            this.collectionTransformer.transform(this.journeyTransformer, Array.isArray(data.unprocessedJourneys)
                ? data.unprocessedJourneys.map(uJ => ({ ...uJ, type: 'unprocessed' }))
                : []
            ),
            null != data.currentJourney ? this.journeyTransformer.transform({ ...data.currentJourney, type: 'current' }) : null,
            null != data.newJourney ? this.newJourneyTransformer.transform({ ...data.newJourney, type: 'new' }) : null,
            this.collectionTransformer.transform(this.journeyTransformer, Array.isArray(data.unsnappedJourneys)
                ? data.unsnappedJourneys.map((usJ) => ({ ...usJ, type: 'unsnapped' }))
                : []
            ),
            data.lastActiveDate,
            data.vehicle
        )
    }
}
